module.exports = __webpack_public_path__ + "img/great.5dd950ea.png";